import styled from 'styled-components';
import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';
// import IconButton from '@material-ui/core/IconButton';

export const VideoContainer = styled.div`
  display: flex;
  padding: 1rem;
  ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : `margin-right: -50px;`)}
`;

export const CloseBtn = styled(Fab)`
  right: 50px;
  top: 10px;
  /* height: 33px;
  && {
    background: white;
  } */
`;

export const LinkContainer = styled.div`
  display: flex;
  margin: 0.75rem 0;
  && {
    a {
      display: flex;
      color: ${({ theme }) => theme.grey[500]};
      align-items: center;
      text-decoration: none;
      svg {
        font-size: 1.3rem;
      }
    }
  }
`;

export const useClasses = makeStyles((theme) => ({
  video: {
    [theme.breakpoints.down('xs')]: {
      width: '250px',
      height: '175px',
    },
  },
}));
